import { styled } from "@mui/material/styles";
import Button, { ButtonProps } from "@mui/material/Button";
export const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.getContrastText("#611B06"),
  backgroundColor: "#611B06",
  borderRadius: "10px",
  border: "1.5px solid #CCCCCC",
  height: '35px'
}));
